// Add grid split to Featured Story card layout
let docWidth = jQuery(document).outerWidth();
jQuery(".paragraph--type--featured-story-bundle").each( function() {
  if ( (docWidth >= 598) && jQuery(this).hasClass("promoted-story") && jQuery(this).hasClass("story-layout-4") ) {
    jQuery(this).find(".field--name-field-featured-stories-paragraph > div").addClass("grid-col-4").first().removeClass("grid-col-4").addClass("grid-col-12");
    jQuery(this).find(".single-featured-story").addClass("grid-row");
    jQuery(this).find(".single-featured-story").children("div").addClass("grid-col-12");
    jQuery(this).find(".single-featured-story").first().children("div").removeClass("grid-col-12").addClass("grid-col-6");
  }
  else if ( (docWidth >= 598) && jQuery(this).hasClass("promoted-story") && jQuery(this).hasClass("story-layout-6") ) {
    jQuery(this).find(".field--name-field-featured-stories-paragraph > div").addClass("grid-col-6").first().removeClass("grid-col-6").addClass("grid-col-12");
    jQuery(this).find(".field--name-field-featured-stories-paragraph > div").first().find(".single-featured-story").addClass("grid-row").find(" > div").addClass("grid-col-6");
  }
  else if ( jQuery(this).hasClass("story-layout-4") ) {
    jQuery(this).find(".field--name-field-featured-stories-paragraph > div").addClass("grid-col-4");
  }
  else if ( jQuery(this).hasClass("story-layout-6") ) {
    jQuery(this).find(".field--name-field-featured-stories-paragraph > div").addClass("grid-col-6");
  }
  else if ( jQuery(this).hasClass("story-layout-12") ) {
    jQuery(this).find(".field--name-field-featured-stories-paragraph > div").addClass("grid-col-12");
  }
});


jQuery(".paragraph--type--focus-on-bundle").each( function() {
  if ( jQuery(this).hasClass("story-layout-4") ) {
    jQuery(this).find(".field--name-field-featured-stories-paragraph > div").addClass("grid-col-4");
  }
  else if ( jQuery(this).hasClass("story-layout-6") ) {
    jQuery(this).find(".field--name-field-featured-stories-paragraph > div").addClass("grid-col-6");
  }
});

// Apply Horizontal Layout for Promoted Featured Stories.
jQuery(window).resize(function() {
  let docWidth = jQuery(document).outerWidth();
  jQuery(".paragraph--type--featured-story-bundle").each( function() {
    if ( (docWidth < 598) && jQuery(this).hasClass("promoted-story") ) {
      jQuery(this).find(".field--name-field-featured-stories-paragraph > div").first().removeClass("grid-col-12").addClass("grid-col-4");
      jQuery(this).find(".single-featured-story").removeClass("grid-row").first().children("div").removeClass("grid-col-6").addClass("grid-col-12");
    }
    else if ( (docWidth >= 598) && jQuery(this).hasClass("promoted-story") ) {
      jQuery(this).find(".field--name-field-featured-stories-paragraph > div").first().removeClass("grid-col-4").addClass("grid-col-12");
      jQuery(this).find(".single-featured-story").addClass("grid-row").first().children("div").removeClass("grid-col-12").addClass("grid-col-6");
    }
  });
});

// Adds Flex if an Agency Card has a layout region as a direct parent
jQuery(".agency-card-container").each(function() {
  if (jQuery(this).parent(".layout__region")) {
    jQuery(this).parent(".layout__region").addClass("addFlex");
  }
});

// All Modular Cards in a Layout row share the same height.
// Function to even out the heights.
function equalizeHeights(selector) {
  var heights = [];

  // Loop to get all element heights
  jQuery(selector).each(function() {

    // Need to let sizes be whatever they want so no overflow on resize
    jQuery(this).css('min-height', '0');
    jQuery(this).css('max-height', 'none');
    jQuery(this).css('height', 'auto');

    // Then add size (no units) to array
    heights.push(jQuery(this).height());
  });

  // Find max height of all elements
  var max = Math.max.apply( Math, heights );

  // Set all heights to max height
  jQuery(selector).each(function() {
    jQuery(this).css('height', max + 'px');
  });
}

// Get the elements to size evenly.
jQuery(window).on('load', function() {
  if ( jQuery(".layout").length ) {
    jQuery(".layout").each(function () {
      if (jQuery(".agency-card-container").length) {
        var sectionCards = jQuery(this).find(".agency-card-container");
        // Fix heights on page load
        equalizeHeights(sectionCards);

        // Fix heights on window resize.
        var iv = null;
        jQuery(window).resize(function() {

          if(iv !== null) {
            window.clearTimeout(iv);
          }

          // Needs to be a timeout function so it doesn't fire every ms of resize.
          iv = setTimeout(function() {
            equalizeHeights(sectionCards);
          }, 60);
        });
      }
    });
  }
});

// Adds classes for Agency Homepages
jQuery(document).ready(function () {
  if (jQuery('.cd-main-content').find('.agency-homepage').length) {
      jQuery('.pre-content').addClass("homepage");
  }
});
